import { render, staticRenderFns } from "./LiveKitRoom.vue?vue&type=template&id=2e8a69bb&scoped=true"
import script from "./LiveKitRoom.vue?vue&type=script&lang=js"
export * from "./LiveKitRoom.vue?vue&type=script&lang=js"
import style0 from "./LiveKitRoom.vue?vue&type=style&index=0&id=2e8a69bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8a69bb",
  null
  
)

export default component.exports